// Dedicated public reviews page — /reviews
import { SEO } from "@/lib/seo";
import { MarketingHeader } from "@/components/marketing/MarketingHeader";
import { MarketingFooter } from "@/components/marketing/MarketingSections2";
import { ReviewCard, Stars, useReviews } from "@/components/marketing/ReviewsSection";
import { Quote } from "lucide-react";

export default function Reviews() {
  const { reviews, stats, loading } = useReviews(100);
  return (
    <div className="min-h-screen bg-[#f6f5f1] text-[#142635] overflow-x-clip" data-testid="reviews-page">
      <SEO title="Fieldlink NZ reviews — what civil construction teams say"
        description="Real reviews from NZ civil contractors running Fieldlink for takeoffs, jobs, crews, plant, safety and invoicing." />
      <MarketingHeader />
      <main className="max-w-[1520px] mx-auto px-5 lg:px-8 py-16 lg:py-24">
        <div className="flex items-center gap-2 text-[#a63c0b]"><Quote className="w-5 h-5" /><span className="text-xs font-bold uppercase tracking-widest">Reviews</span></div>
        <h1 className="mt-3 font-display font-black text-4xl lg:text-6xl tracking-tight">What NZ civil teams say about Fieldlink</h1>
        {stats.count > 0 && (
          <div className="mt-5 flex items-center gap-3">
            <Stars value={stats.average} className="w-6 h-6" />
            <span className="text-2xl font-black">{stats.average.toFixed(1)}</span>
            <span className="text-[#52616c]">from {stats.count} review{stats.count === 1 ? "" : "s"}</span>
          </div>
        )}
        <div className="mt-10">
          {loading ? (
            <div className="text-[#52616c]">Loading reviews…</div>
          ) : reviews.length === 0 ? (
            <div className="rounded-xl border border-[#cbd3d5] bg-white p-10 text-center text-[#465562]">Reviews from our customers will appear here soon.</div>
          ) : (
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
              {reviews.map((r) => <ReviewCard key={r.id} r={r} />)}
            </div>
          )}
        </div>
      </main>
      <MarketingFooter />
    </div>
  );
}
